import axios from 'axios'
import { AppEvents, STORAGE_KEYS } from 'src/constants'
import authService from './auth.service'

const axiosInstance = axios.create()

let isRefreshing = false

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true
      const tokens = await authService.refreshToken()
      try {
        if (tokens) {
          localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken)
          originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`
          return axiosInstance(originalRequest)
        }

        const event = new CustomEvent(AppEvents.APP_LOG_OUT)
        document.dispatchEvent(event)
      } catch (refreshError) {
        const event = new CustomEvent(AppEvents.APP_LOG_OUT)
        document.dispatchEvent(event)
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }
    return Promise.reject(error)
  },
)

export { axiosInstance }
